import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const ease = [0.22, 1, 0.36, 1] as const;

const LifestylePhilosophy = () => {
  const { t } = useLanguage();

  return (
    <section className="py-28 md:py-40 bg-warm-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div
          className="w-full h-full"
          style={{
            backgroundImage: "radial-gradient(circle at 1px 1px, hsl(var(--primary-foreground)) 1px, transparent 0)",
            backgroundSize: "48px 48px",
          }}
        />
      </div>
      <div className="container-luxury max-w-2xl text-center relative z-10">
        <motion.span
          className="font-label text-bronze text-[10px] tracking-[0.35em] block mb-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.8, ease }}
        >
          {t("Philosophy", "Filosofie")}
        </motion.span>

        <motion.h2
          className="font-display text-2xl md:text-4xl lg:text-5xl text-primary-foreground tracking-wide uppercase leading-[1.1] mb-10"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.8, delay: 0.1, ease }}
        >
          {t("A More Refined", "Een Meer Verfijnde")}
          <br />{t("Approach to Living", "Benadering van Leven")}
        </motion.h2>

        <motion.div
          className="w-10 h-px bg-bronze/30 mx-auto mb-10"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.25, ease }}
        />

        <motion.p
          className="font-body text-primary-foreground/50 text-sm md:text-base leading-[2] mb-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.8, delay: 0.35, ease }}
        >
          {t(
            "A lifestyle shaped by access, discretion, and a quiet understanding that true luxury lies in the absence of friction. Where decisions are simplified, time is protected, and every element is already in place before it is needed.",
            "Een levensstijl gevormd door toegang, discretie en het stille besef dat ware luxe schuilt in de afwezigheid van wrijving. Waar beslissingen worden vereenvoudigd, tijd wordt beschermd en elk element al op zijn plaats is voordat het nodig is."
          )}
        </motion.p>

        <motion.p
          className="font-display text-primary-foreground/40 text-lg md:text-xl tracking-wide leading-[1.8]"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.8, delay: 0.5, ease }}
        >
          {t("It is not about more —", "Het gaat niet om meer —")}
          <br />{t("but about less to think about.", "maar om minder om over na te denken.")}
        </motion.p>
      </div>
    </section>
  );
};

export default LifestylePhilosophy;
